import Promise from 'promise-polyfill';
window.Promise = window.Promise || Promise;

import debounce from 'lodash/debounce';
import anime from 'animejs';

const 	heroBannerHome = document.querySelector('.js-hero-banner-home');

let 	contentOuterWrap,
		nav,
		allContent,
		content1,
		content2,
		content3,
		button1,
		button2,
		button3,
		images;

function removeCurrentBanner() {
	
	const currentBanner = heroBannerHome.querySelector('.is-active');

	disableNav();

	return anime({
		targets: currentBanner.children,
		opacity: 0,
		translateX: [0, 10],
		easing: 'cubicBezier(0.250, 0.100, 0.250, 1.000)',
		duration: 300,
		delay: anime.stagger(100),
		complete: function() {
			currentBanner.classList.remove('is-active');
		}
	});
}

function getTallestContent() {

	return 	[...allContent]
				.map( item => {
					return item.clientHeight;
				})
				.reduce( (prev, current) => {
					return prev > current ? prev : current;
				});
}

function setBannerHeight() {
	contentOuterWrap.style.height = 'auto';
	contentOuterWrap.style.height = `${getTallestContent()}px`;
}

function bannerHeightAuto() {
	contentOuterWrap.style.height = 'auto';
}

function disableNav() {
	nav.classList.add('is-disabled');
}

function enableNav() {
	nav.classList.remove('is-disabled');
}

function showBanner( banner, index ) {
	anime({
		targets: banner.children,
		opacity: [0, 1],
		translateX: [10, 0],
		easing: 'cubicBezier(0.250, 0.100, 0.250, 1.000)',
		duration: 300,
		delay: anime.stagger(100),
		begin: () => {
			banner.classList.add('is-active');
		}, 
		complete: () => {
			enableNav();
		}
	});
	
	// animate banner
	anime({
		targets: images[index],
		opacity: [0, 1],
		easing: 'cubicBezier(0.250, 0.100, 0.250, 1.000)',
		duration: 600,
		begin: () => {
			images.forEach( item => {
				item.style.zIndex = '0';
			});
			images[index].style.zIndex = '1';
		},
		complete: () => {
			images.forEach( (item, i) => {
				if ( i !== index ) {
					item.style.opacity = '0';
				}
			});
		}
	});
}

function makeNavItemActive(item) {
	document.querySelectorAll('.js-nav-item').forEach( item => {
		item.classList.remove('is-active');
	});

	item.closest('.js-nav-item').classList.add('is-active');
}

function showBanner1(e) {
	if ( e.target.closest('.js-nav-item').classList.contains('is-active') ) {
		return false
	}
	makeNavItemActive(e.target);
	removeCurrentBanner().finished.then(() => {
		showBanner( content1, 0 );
	});
}

function showBanner2(e) {
	if ( e.target.closest('.js-nav-item').classList.contains('is-active') ) {
		return false
	}
	makeNavItemActive(e.target);
	removeCurrentBanner().finished.then(() => {
		showBanner( content2, 1 );
	});
}

function showBanner3(e) {
	if ( e.target.closest('.js-nav-item').classList.contains('is-active') ) {
		return false
	}
	makeNavItemActive(e.target);
	removeCurrentBanner().finished.then(() => {
		showBanner( content3, 2 );
	});
}

if ( heroBannerHome ) {
	
	contentOuterWrap = heroBannerHome.querySelector('.js-content-outer-wrap'),
	nav = heroBannerHome.querySelector('.js-nav'),
	allContent = heroBannerHome.querySelectorAll('.js-content'),
	content1 = heroBannerHome.querySelector('.js-content-1'),
	content2 = heroBannerHome.querySelector('.js-content-2'),
	content3 = heroBannerHome.querySelector('.js-content-3'),
	button1 = heroBannerHome.querySelector('.js-button-1'),
	button2 = heroBannerHome.querySelector('.js-button-2'),
	button3 = heroBannerHome.querySelector('.js-button-3'),
	images = heroBannerHome.querySelectorAll('.js-images img');

	if ( content1 && button1 ) {
		button1.addEventListener('click', showBanner1);
	}

	if ( content2 && button2 ) {
		button2.addEventListener('click', showBanner2);
	}

	if ( content3 && button3 ) {
		button3.addEventListener('click', showBanner3);
	}

	setBannerHeight();

	window.addEventListener('resize', debounce(setBannerHeight, 250));
	
	window.setTimeout( () => {
		showBanner( content1, 0 );
	}, 250)
}